const questions = [
  {
    questionId: 1,
    theme: 'Shareholder voting participation',
    questionType: 'donut',
    answerType: 'single',
    questionName: 'Participation',
    questionText: 'What percentage of shares were voted on by individual investors in 2020?',
    answerInfo: {
      text:
        'As a group, institutional investors voted 92% of the shares they held during the 2020 season, up from 90% in 2019. While voting by individual shareholders held steady at 28% of the shares they own.',
      source: {
        text: 'Source: Proxypulse 2020',
        url: 'https://www.broadridge.com/resource/2020-proxy-season-review',
      },
    },
    options: ['28%', '38%', '48%', '58% '],
    correct: 0,
  },
  {
    questionId: 2,
    theme: 'By the numbers',
    questionType: 'chart',
    answerType: 'single',
    questionName: 'Returns',
    questionText:
      'According to the Diligent Institute, how does the equity return of companies ranked in the top 20% for good governance compare to return of companies in the S&P 500 Index?',
    options: ['Option 1', 'Option 2', 'Option 3'],
    correct: 0,
    answerInfo: {
      text:
        'A recent Diligent Institute report found that companies with strong corporate governance (the top 20%), based on criteria related to shareholder rights, board composition and independence and compensation, outpaced the S&P 500 Index and outperformed the bottom 20% by 17 pts.',
      source: {
        text: 'Source: Diligent Institute',
        url:
          'https://www.diligentinstitute.com/wp-content/uploads/2019/05/dil_inst_whitepaper_modern_governance.pdf',
      },
    },
    chartConfig: {
      label: 'S&P500',
      yDomain: {
        min: 100,
        max: 160,
        range: 60,
      },
      xAxis: [
        'Nov',
        "Jan '19",
        'Mar',
        'May',
        'Jul',
        'Sep',
        'Nov',
        "Jan '20",
        'Mar',
        'May',
        'Jul',
        'Sep',
        'Nov',
        "Jan '21",
      ],
      yAxis: [100, 110, 120, 130, 140, 150, 160],
    },
  },
  {
    questionId: 3,
    theme: 'By the numbers',
    questionType: 'list',
    answerType: 'single',
    questionName: 'The numbers',
    questionText:
      'In the 2020 Proxy season, how many environmental and social shareholder proposals were voted on?',
    answerInfo: {
      text:
        'There were a total of 440 shareholder proposals submitted for a vote in 2020, of which 33% were environmental and social related.  Interest in environmental and social issues is expected to continue in 2021 as more shareholders look to have their investments align with their values.',
      source: {
        text: 'Source: Broadridge Proxy Data',
        url: '',
      },
    },
    options: ['143', '253', '363', '473'],
    correct: 0,
  },
  {
    questionId: 4,
    theme: 'Hot topics',
    questionType: 'list',
    answerType: 'single',
    questionName: 'Themes',
    questionText:
      'What was the most common environmental/social shareholder proposal topic from the 2020 Proxy Season?',
    answerInfo: {
      text:
        'Proposals to report on political lobbying was the most prevalent of environmental/social topic in 2020 – not surprising given 2020 was a major election year in the U.S.',
      source: {
        text: 'Source: Broadridge Proxy Data',
        url: '',
      },
    },
    options: [
      'Animal Rights',
      'Environmental / Climate',
      'Human Rights / Diversity',
      'Political / Government',
    ],
    correct: 3,
  },
  {
    questionId: 5,
    theme: 'Hot topics',
    questionType: 'list',
    answerType: 'single',
    questionName: 'Top theme',
    questionText:
      'What environmental/social proposal topic received the most votes and passed in Proxy Season 2020?',
    answerInfo: {
      text:
        'Johnson & Johnson’s “Report on Governance of Opioids-Related Risks” shareholder proposal received the most votes and passed in 2020.',
      source: {
        text: 'Source: Broadridge Proxy Data',
        url: '',
      },
    },
    options: ['Environmental / Climate', 'Executive Pay', 'Health', 'Human Rights / Diversity'],
    correct: 2,
  },
  {
    questionId: 6,
    theme: 'Get on board',
    questionType: 'bar',
    answerType: 'single',
    questionName: 'Reelection',
    questionText:
      'Over 21,000 directors stood for election during the 2020 Proxy Season. What percentage failed to receive majority support (at least 50% of the votes cast in favor)?',
    answerInfo: {
      text:
        'A total of 21,358 directors stood for election this season. On average, shareholder support for directors held steady at 95%. However, 453 directors failed to attain majority support.',
      source: {
        text: 'Source: Proxypulse 2020',
        url: 'https://www.broadridge.com/resource/2020-proxy-season-review',
      },
    },
    options: ['2%', '11%', '15%', '20%', '30%'],
    chartLabel: 'Directors that fail reelection',
    correct: 0,
  },
  {
    questionId: 7,
    theme: 'Get on board',
    questionType: 'pie',
    answerType: 'single',
    questionName: 'Gender',
    questionText: 'What percentage of board of director seats are held by women in the U.S.?',
    answerInfo: {
      text:
        '“Research from scholars and organizations has found that women need to hold at least three board seats to create a “critical mass,” which can lead to better financial performance. Reaching critical mass can change boardroom dynamics substantially, creating an environment in which innovative ideas can spring from gender diversity.”',
      source: {
        text: 'Source: Catalyst.org',
        url: 'https://www.catalyst.org/research/women-on-corporate-boards/',
      },
    },
    options: ['16%', '26%', '36%', '46%', '56%'],
    correct: 1,
  },
]

export default questions
